import { Box, Grid, Tab, Tabs } from "@mui/material";
import React from "react";
// import Purchase from "../purchase/purchase";
import Stocks from "../stocks/stocks";
import { useSelector } from "react-redux";
// import FranchiseInformation from "./consultantInformation";
// import FranchiseRequirement from "./FranchiseRequirenment";
// import FranchiseSupport from "./FranchiseSupport";
// import Enquiries from "./enquiries";
// import UploadImage from "./UploadImage";
import ConsultantInformation from "./consultantInformation";
import Enquiries from "./enquiries";
import BusinessProfileConsultant from "./BusinessProfileConsultant";

export const MyConsultant = ({}) => {
  const [value, setValue] = React.useState("all");
  const [enquiries, setEnquiries] = React.useState(null);
  const handleChange = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          {(!businessChooseTab ||
            businessChooseTab?.value == "Consultantinformation") && (
            <ConsultantInformation />
          )}
          {(!businessChooseTab ||
            businessChooseTab?.value == "consultantBusinessProfile") && (
            <BusinessProfileConsultant />
          )}

          {(!businessChooseTab || businessChooseTab?.value == "enquiries") && (
            <Enquiries />
          )}
          {/* {businessChooseTab?.value == "course" && (
            <>
              {!enquiries && (
                <Course
                  clickEnquire={(da) => {
                    setEnquiries(da);
                  }}
                />
              )}
              {enquiries && (
                <Enquiries
                  enquiries={enquiries}
                  backEnquire={() => {
                    setEnquiries(null);
                  }}
                />
              )}
            </>
          )} */}
        </Grid>
      </Grid>
    </Box>
  );
};
